import { css } from '@emotion/core'

export const getFixedSizeColumnStyles = () =>
  // `!important` is required to make sure that inline styles from `react-table` are overridden correctly.
  css`
    flex-shrink: 0 !important;
    flex-grow: 0 !important;
  `
